import { Controller, useForm } from "react-hook-form";
import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { isFunction } from "lodash";
import NumberFormat from "react-number-format";
import React, { useEffect, useRef } from "react";
import FizenInput from "components/form/FizenInput";

function Form({
  formModel,
  onFinish,
  initialValue,
  formButton,
  validationSchema,
  form,
  style = "light",
  enableReInitialValue,
  autofocus,
  ...props
}) {
  const privateForm = useForm({
    defaultValues: initialValue,
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
  });

  const {
    watch,
    control,
    handleSubmit,
    // setValue,
    reset,
    formState: { errors },
  } = form ?? privateForm;
  const inputRef = useRef();

  useEffect(() => {
    if (enableReInitialValue) {
      console.log(initialValue);
      reset(initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableReInitialValue, initialValue]);

  useEffect(() => {
    if (autofocus) {
      inputRef.current.focus();
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autofocus, inputRef]);

  const onSubmit = (data) => onFinish(data);

  const resetFields = () => {
    console.log("reset");
    reset(initialValue);
  };

  return (
    <form {...props} onSubmit={handleSubmit(onSubmit)}>
      {Object.entries(formModel).map(([key, value], idx) => {
        switch (value.type) {
          case "string":
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                // rules={value.rules}
                render={
                  ({ field }) => (
                    // style === "light" ? (
                    //   <TextField
                    //     {...field}
                    //     error={!!errors[key]}
                    //     helperText={errors[key]?.message}
                    //     label={value.label}
                    //     sx={value.sx}
                    //     autoFocus={idx === 0}
                    //     variant="filled"
                    //   />
                    // ) : (
                    <FizenInput
                      {...field}
                      error={!!errors[key]}
                      helperText={errors[key]?.message}
                      label={value.label}
                      sx={value.sx}
                      autoFocus={idx === 0}
                    />
                  )
                  // )
                }
              />
            );
          case "password":
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                // rules={value.rules}
                render={
                  ({ field }) => (
                    // style === "light" ? (
                    //   <TextField
                    //     {...field}
                    //     label={value.label}
                    //     sx={value.sx}
                    //     type="password"
                    //     error={!!errors[key]}
                    //     helperText={errors[key]?.message}
                    //     autoFocus={idx === 0}
                    //   />
                    // ) : (
                    <FizenInput
                      {...field}
                      label={value.label}
                      sx={value.sx}
                      type="password"
                      error={!!errors[key]}
                      helperText={errors[key]?.message}
                      autoFocus={idx === 0}
                      variant="filled"
                    />
                  )
                  // )
                }
              />
            );
          case "number":
            console.log(initialValue[key]);
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                // rules={value.rules}
                render={({ field }) => {
                  return (
                    // <TextField
                    //     {...field}
                    //     error={!!errors[key]}
                    //     helperText={errors[key]?.message}
                    //     label={value.label}
                    //     sx={value.sx}
                    //     InputProps={{
                    //       inputComponent: NumberInput
                    //     }}
                    // />

                    <NumberFormat
                      customInput={FizenInput}
                      onValueChange={(v) => {
                        if (value.autoParseNumber) {
                          field.onChange(v.floatValue);
                        } else {
                          field.onChange(v.value);
                        }
                      }}
                      value={field.value}
                      thousandSeparator
                      isNumericString
                      decimalScale={value.decimalScale}
                      prefix={value.prefix}
                      error={!!errors[key]}
                      helperText={errors[key]?.message}
                      label={value.label}
                      sx={value.sx}
                      autoFocus={idx === 0}
                      variant="filled"
                      disabled={value.disable}
                      allowNegative={value.allowNegative}
                    />
                  );
                }}
              />
            );
          case "select":
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                // rules={value.rules}
                render={({ field: { onChange, ...props } }) => {
                  if (!value.options) {
                    value.options = [];
                  }
                  const index = value.options.findIndex((item) => item.value === props.value);
                  const init = value.options[index];
                  return (
                    <Autocomplete
                      sx={value.sx}
                      getOptionLabel={(option) => option.label}
                      options={value.options}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={value.label}
                          error={!!errors[key]}
                          helperText={errors[key]?.message}
                        />
                      )}
                      onChange={(e, data) => onChange(data?.value)}
                      value={init}
                    />
                  );
                }}
              />
            );
          case "multiple-select":
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                // rules={value.rules}
                render={({ field: { onChange, ...props } }) => {
                  if (!value.options) {
                    value.options = [];
                  }
                  console.log(props);
                  // if (isString(value.options[0])) {
                  //   return (
                  //     <Autocomplete
                  //       sx={value.sx}
                  //       multiple
                  //       // getOptionLabel={(option) => option.label}
                  //       options={value.options}
                  //       renderInput={(params) => (
                  //         <TextField
                  //           {...params}
                  //           label={value.label}
                  //           error={!!errors[key]}
                  //           helperText={errors[key]?.message}
                  //         />
                  //       )}
                  //       onChange={(e, data) => {
                  //         console.log(data);
                  //         onChange(data);
                  //       }}
                  //       defaultValue={props.value}
                  //     />
                  //   );
                  // }
                  return (
                    <Autocomplete
                      sx={value.sx}
                      multiple
                      getOptionLabel={(option) =>
                        value.mappingLabel ? value.mappingLabel[option] ?? option : option
                      }
                      options={value.options}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={value.label}
                          error={!!errors[key]}
                          helperText={errors[key]?.message}
                        />
                      )}
                      onChange={(e, data) => {
                        if (value.limitTags) {
                          if (data.length <= value.limitTags) {
                            onChange(data);
                          }
                        } else {
                          onChange(data);
                        }
                      }}
                      value={props.value}
                      // defaultValue={props.value}
                    />
                  );
                }}
              />
            );
          case "radio":
            return (
              <FormControl key={key} component="fieldset">
                <FormLabel component="legend">{value.label}</FormLabel>
                <Controller
                  control={control}
                  name={key}
                  defaultValue={initialValue[key]}
                  render={({ field }) => {
                    console.log(field);
                    return (
                      <RadioGroup
                        {...field}
                        value={field.value}
                        row
                        className={`flex ${
                          value.direction === "column" ? "flex-col" : ""
                        } justify-center`}
                      >
                        {value.options.map((option, idx) => (
                          <React.Fragment key={idx}>
                            <FormControlLabel
                              // className="w-3/4"
                              key={idx}
                              value={option.key}
                              control={<Radio key={idx} />}
                              label={option.label}
                            />
                          </React.Fragment>
                        ))}
                      </RadioGroup>
                    );
                  }}
                />
              </FormControl>
            );
          case "textarea":
            return (
              <Controller
                key={key}
                name={key}
                control={control}
                defaultValue={initialValue[key]}
                render={({ field }) => (
                  <FizenInput
                    inputRef={inputRef}
                    {...field}
                    error={!!errors[key]}
                    helperText={errors[key]?.message}
                    label={value.label}
                    sx={value.sx}
                    // autoFocus={true}
                    multiline
                    rows={4}
                    disabled={value.disable}
                  />
                )}
              />
            );
          default:
            return <></>;
        }
      })}
      {/*<input type="submit" />*/}
      {isFunction(formButton)
        ? formButton({ control, currentValue: watch(), setValue: reset, resetFields })
        : formButton}
    </form>
  );
}

export default Form;
